export enum TaskType {
    Standard = 1,
    WebsiteRegistration = 2,
    PropertyVisitReminder = 3,
    AppointmentFollowUp = 4,
    TelephoneCall = 5,
    CustodialSchemeDeposit = 6,
    RentReview = 7,
    PropertyDisintruction = 8,
    Progression = 9,
    Signable = 10,
    AgencyExpress = 11,
    WebsiteContactRequest = 12,
    WebsitePropertyEnquiry = 13,
    WebsiteValuation = 14,
    TenantShop = 15,
    CountryWideSigns = 16,
    CreditSafe = 17,
    Notify = 18,
    DepositRegistrationError = 19,
    Vorensys = 20,
    PropertyValuation = 21
}